import React, { useEffect, useState } from "react";
import { CheckBox } from "./../../components/checkbox/checkbox";
import { Label } from "./../../components/checkbox/label";
import Question from "./../../components/question/question";
import { Radio } from "./../../components/radio_buutons/radio";
import { selectQuestionCounterOrCharacter } from "./QuizRunner.helpers";
import { GradingAIFeedback } from "../../components/ai_feedback/GradingAIFeedback.jsx";
import PropTypes from "prop-types";
import { ShowSequence } from "./QuizRunner.helpers";
import { CorrectAnswer } from "../../components/answers/correct_answer";
import { WrongAnswer } from "../../components/answers/wrong_answer";
import ReactHtmlParser from "react-html-parser";
import { isInUserSelectedAnswers } from "./QuizRunner.helpers";
import { size, includes } from "lodash";
import { DragAndDropRunner } from "./DragAndDropRunner";
import { InputMultiSelectTypeQuestion } from "./InputMultiSelectTypeQuestion";
import { InputTypeQuestion } from "./InputTypeQuestion";
import { exerciseType } from "../../components/constants/constants";
import {handleAnswersInput} from  "../../components/edit_quiz_helper/EditQuizHelper.jsx"
import { type } from "./QuizRunner";
import { QuizyUrl, isB2C, isNovium } from "../../libs/env";
import { StaticAIFeedback } from "../../components/ai_feedback/StaticAIFeedback.jsx";

export const ShowQuestions = React.memo(({
  questions,
  onAnswer,
  task_type,
  currentPage,
  isReview,
  answer,
  status,
  exercise_id,
  section_id,
  page_id,
  data,
  ai_grading_exercise,
  onUpdate,
  setanswerSheet,
  comp_answer,
  print_options,
  setoptionsSheet,
  quesRef,
}) => {
  let params = new URL(document.location).searchParams;
  let quizy_template = params.get("quizy_template")
  let inputFiledLength = [];
  let isFielddisabled=false;
  let margin = "mb-3";
  let margintop0 = "mt-2";
  let formChecksize = "custom-form-check";
  let margin_counter = "me-2";
  // if(pathname.includes(TempUrl) || edit_template === "true")
  // {
  //   isFielddisabled = true;
  //   // margin_counter= "me-1";
  //   // margin = "mb-1";
  //   // margintop0 = "mt-0";
  //   // formChecksize = "preview-form-check";

  // }
  questions.forEach((question, index) => {
  if (question.possible_answers && question.type !== "RadioBox" && question.type !== "CheckBox"){
    question.possible_answers.forEach((possible_answer) => {
      var question_number = 1;
      if (possible_answer.is_correct === true) {
        if (questions.length > 1)
        {
          question_number = index + question_number
          comp_answer += `<div> ${question_number}.${possible_answer.number}  
          <span class="ps-2 fw-900">${possible_answer.prompt_content}</span></div>` 
        }
        else{
          question_number = possible_answer.number
          comp_answer += `<div> ${question_number}.  
          <span class="fw-900">${possible_answer.prompt_content}</span></div>`
        }
      }
    });
    if(window.location.origin.includes(QuizyUrl))
    {
      setanswerSheet(comp_answer);
    }
  }
  });
  questions.forEach((question, index) => {
    if (question.possible_answers && question.type === "FillInBlankChoices"){
      var pai_number = 0
      question.possible_answers.forEach((possible_answer) => {
        var question_number = 1;
        if (questions.length > 1)
        {
          question_number = index + question_number
          if(pai_number === 0)
          {
            print_options += `<div>${question_number}.${possible_answer.number}  
            <span class="ps-2">${possible_answer.prompt_content}, </span>`
            pai_number = possible_answer.number
          }
          else if (possible_answer.number === pai_number)
          {
            print_options += `<span>${possible_answer.prompt_content}, </span>`
          } 
          else{
            print_options += `</div><div> ${question_number}.${possible_answer.number}  
            <span class="ps-2">${possible_answer.prompt_content}, </span>`
            pai_number = possible_answer.number
          }
        }
        else{
          question_number = possible_answer.number
          if(pai_number === 0)
          {
            print_options += `<div> ${question_number}.
            <span class="ps-2">${possible_answer.prompt_content}, </span>`
            pai_number = possible_answer.number
          }
          else if (possible_answer.number === pai_number)
          {
            print_options += `<span>${possible_answer.prompt_content}, </span>`
          } 
          else{
            print_options += `</div><div> ${question_number}.  
            <span class="ps-2">${possible_answer.prompt_content}, </span>`
            pai_number = possible_answer.number
          }
        }
      });
      print_options += `</div>`
      if(window.location.origin.includes(QuizyUrl))
      {
        setoptionsSheet(print_options);
      }
    }
  });
  let checkflag = false;
  const [currentQuestion, setCurrentQuestion] = useState(currentPage);
  
  const [Questionedit, setQuestionedit] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);
  const focusBlink = (e) => {
    setIsBlinking(false);
  }
  const blurBlink = (e) => {
    if(Questionedit)
    {
      setIsBlinking(true);
    }
  }
  useEffect(() => {
    setCurrentQuestion(currentPage);
  }, [currentPage]);

  let isShowNumbering = size(questions) > 1;
  let fieldNumber,
    fieldlenght = 0;
    
  return (
    <div>
    <div ref={data && data?.questions?.length > 1 ? (quesRef):null} className="col-12">
      {questions &&
        questions.map((question, qai) => {
          if (
            isReview ||
            status === null ||
            parseInt(currentQuestion) === parseInt(question.page)
          ) {
            question.prompt_content.replace(
              /\[\[[^\]]*\]\]\*([\d]+)/g,
              function replacer(matched) {
                matched.replace(/\[\[[^\]]*\]\]/g, function replace(match) {
                  fieldNumber = match.match(/\d+/);
                });
                matched.replace(/\*([\d]+)/g, function replacer(matched) {
                  fieldlenght = matched.match(/\d+/);
                });
                inputFiledLength.push({
                  questionNumber: question.id,
                  fieldNumber: fieldNumber[0],
                  fieldlenght: fieldlenght[0],
                });
              }
            );
            const trimedString = question.prompt_content.trim();
            const converted = trimedString.replace(
              /\[\[([^\]]*)\]\](?: *\[(.*?)\])?/g,
              function replacer(matched, dataID, placeholderText) {
                return question.type === "FillInBlank"
                  ? `<input type="text" className="form-control-sm" placeholder="${placeholderText || ""}" data-id ="${dataID}"  class="inline"/>`
                  : question.type === "DragAndDrop"
                  ? `<span data-type="${
                      question.type
                    }" type="text" className="form-control-sm" data-id ="${matched.match(
                      /\d+/
                    )}"  ></span>`
                  : `<select data-id ="${matched.match(
                      /\d+/
                    )}"  class="inline"></select>`;
              }
            );

            return (
              <div>
                {includes(question.type, "Drag") ? (
                  <>
                  <DragAndDropRunner
                    exercise_id={exercise_id}
                    data_possible_type={data.type}
                    section_id={section_id}
                    page_id={page_id}
                    question={question}
                    converted={converted}
                    isShowNumbering={isShowNumbering}
                    qai={qai}
                    answer={answer}
                    isReview={isReview}
                    Questionedit={Questionedit}
                    isBlinking={isBlinking}
                    setIsBlinking={setIsBlinking}
                    focusblink={focusBlink}
                    blurblink={blurBlink}
                    data={data}
                    isFielddisabled={isFielddisabled}
                  />
                  {isReview && (data.type === type.Exercise || questions?.length !== 1 ) && question?.ai_feedback ? <StaticAIFeedback question={question} all_questions={questions} showLabel={true} /> : null}
                  </>
                ) : (
                  <div className={`${margin}`} key={qai}>
                    <div className="icon-wrapper">
                      <Question
                        // counterClass={getCounterCls(converted)}
                        Questionedit={Questionedit}
                        setQuestionedit={setQuestionedit}
                        isBlinking={isBlinking}
                        focusblink={focusBlink}
                        blurblink={blurBlink}
                        setIsBlinking={setIsBlinking}
                        onUpdate={onUpdate}
                        quesRef={quesRef}
                        qai={qai}
                        data={data}
                        showNumbers={isShowNumbering}
                        DisableQuestionNumbering = {question.disable_question_numbering}
                        counterClass={`${margin_counter}`}
                        counter={qai + 1 + "."}
                        alignement={question.question_alignement}
                        title={ReactHtmlParser(
                          converted.replace(/\*([\d]+)/g, ""),
                          {
                            transform: (node) => {
                              if (node.name === "input") {
                                return (
                                  <InputTypeQuestion
                                    isReview={isReview}
                                    onAnswer={onAnswer}
                                    question={question}
                                    exercise_id={exercise_id}
                                    section_id={section_id}
                                    page_id={page_id}
                                    inputFiledLength={inputFiledLength}
                                    node={node}
                                    data={data}
                                    answer={answer}
                                    isFielddisabled={isFielddisabled}
                                  />
                                );
                              } else if (node.name === "select") {
                                return (
                                  <InputMultiSelectTypeQuestion
                                    isReview={isReview}
                                    onAnswer={onAnswer}
                                    question={question}
                                    exercise_id={exercise_id}
                                    section_id={section_id}
                                    page_id={page_id}
                                    node={node}
                                    data={data}
                                    answer={answer}
                                    isFielddisabled={isFielddisabled}
                                  />
                                );
                              }
                            },
                          }
                        )}
                      />
                      {question.type === "RadioBox" ||
                      question.type === "CheckBox" ? (
                        <div data-tc={ question.type === "CheckBox" ? "Checkbox-question" : "Radiobox-question" }
                          className={
                            question.question_horizontal_display
                              ? "row d-inline-flex  align-items-end "
                              : null
                          }
                        >
                          {(question.possible_answers).map((possible_answers, pai) => (
                            <div
                              className={
                                question.type === "RadioBox" ||
                                question.type === "CheckBox"
                                  ? question.question_horizontal_display
                                    ? `d-flex ${margintop0} ms-3 inline-grid col`
                                    : `d-flex ${margintop0} ms-3`
                                  : null
                              }
                            >
                              <label for={possible_answers.id}>
                                {possible_answers.image &&
                                question.question_horizontal_display ? (
                                  <img
                                    src={possible_answers.image}
                                    height={possible_answers.image_height}
                                    px
                                    alt="img"
                                  />
                                ) : (
                                  ""
                                )}
                              </label>
                              <div
                                className={
                                  question.type === "RadioBox" ||
                                  question.type === "CheckBox"
                                    ? `form-check d-flex align-items-center form-check-inline ${formChecksize}`
                                    : null
                                }
                              >
                                {data.type === type.Assessment
                                  ? answer.forEach((answ) => {
                                      if (
                                        answ.section_id === section_id &&
                                        answ.exercise_id === exercise_id &&
                                        answ.page_id === page_id
                                      ) {
                                        answ.answers.forEach((ans) => {
                                          if (ans.question_id === question.id) {
                                            ans.selected_answers.forEach(
                                              (sel_ans) => {
                                                if (
                                                  possible_answers.id ===
                                                  sel_ans["id"]
                                                ) {
                                                  checkflag = true;
                                                }
                                              }
                                            );
                                          }
                                        });
                                      }
                                    })
                                  : answer.forEach((ans) => {
                                      if (ans.question_id === question.id) {
                                        ans.selected_answers.forEach(
                                          (sel_ans) => {
                                            if (
                                              possible_answers.id ===
                                              sel_ans["id"]
                                            ) {
                                              checkflag = true;
                                            }
                                          }
                                        );
                                      }
                                    })}

                                <span className={Questionedit ? "text-uppercase pe-2" : "text-uppercase"}>
                                  <b>
                                  {question.show_sequence !==
                                  ShowSequence.NoSequenceIndicator
                                    ? selectQuestionCounterOrCharacter({
                                        index: pai,
                                        show_abc_sequence:
                                          question.show_sequence,
                                      }) + "."
                                    : null}
                                  </b>
                                </span>
                                {question.type === "CheckBox" && !Questionedit ? (
                                  <CheckBox
                                  key={question.id}
                                    defaultChecked={
                                      checkflag === true ? checkflag : null
                                    }
                                    index={
                                      selectQuestionCounterOrCharacter({
                                        index: pai,
                                        show_abc_sequence:
                                          question.show_abc_sequence,
                                      }) + "."
                                    }
                                    disabled={isFielddisabled}
                                    data-question-id={question.id}
                                    data-question-type={question.type}
                                    onClick={onAnswer}
                                    value={possible_answers.id}
                                    id={possible_answers.id}
                                    data-exercise-id={exercise_id}
                                    data-section-id={section_id}
                                    data-page-id={page_id}
                                    name={`answers[${qai}].selected_answers[${pai}]`}
                                    checked={
                                      isReview
                                        ? isInUserSelectedAnswers(
                                            question,
                                            possible_answers.id
                                          )
                                        : null
                                    }
                                    className={
                                      isReview &&
                                      !isInUserSelectedAnswers(
                                        question,
                                        possible_answers.id
                                      ) &&
                                      possible_answers.is_correct
                                        ? "form-check-input correct_answers ms-2"
                                        : "form-check-input ms-2"
                                    }
                                  />
                                ) : question.type === "RadioBox" && !Questionedit ? (
                                  <Radio
                                  key={question.id}
                                    defaultChecked={
                                      checkflag === true ? checkflag : null
                                    }
                                    index={
                                      selectQuestionCounterOrCharacter({
                                        index: pai,
                                        show_abc_sequence:
                                          question.show_abc_sequence,
                                      }) + "."
                                    }
                                    disabled={isFielddisabled}
                                    data-question-id={question.id}
                                    data-question-type={question.type}
                                    data-exercise-id={exercise_id}
                                    data-section-id={section_id}
                                    data-page-id={page_id}
                                    onClick={onAnswer}
                                    value={possible_answers.id}
                                    id={possible_answers.id}
                                    name={`answers[${qai}].selected_answers`}
                                    checked={
                                      isReview
                                        ? isInUserSelectedAnswers(
                                            question,
                                            possible_answers.id
                                          )
                                        : null
                                    }
                                    className={
                                      isReview &&
                                      !isInUserSelectedAnswers(
                                        question,
                                        possible_answers.id
                                      ) &&
                                      possible_answers.is_correct
                                        ? "form-check-input correct_answers ms-2"
                                        : "form-check-input ms-2"
                                    }
                                  />
                                ) : null}
                                {(checkflag = false)}
                                <div
                                  class={
                                    question.type === "RadioBox" ||
                                    question.type === "CheckBox"
                                      ? "icon-wrapper"
                                      : null
                                  }
                                >
                                  {question.type === "RadioBox" ||
                                  question.type === "CheckBox" ? (
                                    <Label
                                      for={possible_answers.id}
                                      label={
                                        <div
                                          contentEditable={Questionedit}
                                          spellcheck="false"
                                          data-gramm="false"
                                          onFocus={focusBlink}
                                          onBlur={blurBlink} 
                                          onInput={handleAnswersInput({ques_key: qai, ans_key: pai,quizdata: data})}
                                          dangerouslySetInnerHTML={{
                                            __html: `${
                                              possible_answers.prompt_content
                                                ? possible_answers.prompt_content
                                                : ""
                                            } ${
                                              possible_answers.image &&
                                              !question.question_horizontal_display
                                                ? `<img src=${possible_answers.image} height=${possible_answers.image_height}px/>`
                                                : ""
                                            }`,
                                          }}
                                        />
                                      }
                                    />
                                  ) : null}
                                  {possible_answers.is_correct === true &&
                                    isReview === true &&
                                    (question.type === "CheckBox" ||
                                      question.type === "RadioBox") &&
                                    isInUserSelectedAnswers(
                                      question,
                                      possible_answers.id
                                    ) && (
                                      <CorrectAnswer class="answer-badge bg-success" />
                                    )}

                                  {possible_answers.is_correct === false &&
                                    isReview === true &&
                                    (question.type === "CheckBox" ||
                                      question.type === "RadioBox") &&
                                    isInUserSelectedAnswers(
                                      question,
                                      possible_answers.id
                                    ) && (
                                      <WrongAnswer class="answer-badge bg-danger" />
                                    )}
                                </div>
                              </div>
                              <div className="d-none">
                                {possible_answers && possible_answers.is_correct === true ? (comp_answer += `<div  class="d-flex "> ${qai+1}.  
                                <span class="ps-2">${question.prompt_content}</span>    
                                <span class="text-uppercase fw-900 ps-2">${selectQuestionCounterOrCharacter({
                                  index: pai,
                                  show_abc_sequence:
                                    question.show_abc_sequence,
                                }) + "."}</span></div>`
                                ):null
                                }
                              </div>
                            </div>
                          ))}
                          {window.location.origin.includes(QuizyUrl) && (setanswerSheet(comp_answer))}
                        </div>
                      ) : null}
                    </div>
                    {isReview && (data.type === type.Exercise || questions?.length !== 1 ) && question?.type === "FillInBlank" && ai_grading_exercise ? <GradingAIFeedback question={question} showLabel={true} />
                    : isReview && (data.type === type.Exercise || questions?.length !== 1 ) && question?.ai_feedback ? <StaticAIFeedback question={question} all_questions={questions} showLabel={true} />
                    : null }
                  </div>
                )}
              </div>
            );
          } else {
            return null;
          }
        })}

    </div>
    {task_type !== exerciseType.WRITING_TASK && !(isB2C.some(domain => window.location.origin.includes(domain)) || window.location.origin.includes(isNovium) || quizy_template || window.location.origin.includes(QuizyUrl))  ? (
        <p className="quiz-bottom-border no-download"></p>
      ) : null}
    </div> 
  );
});

ShowQuestions.defaultProps = {
  questions: [],
  currentQuestion: 1,
  isReview: false,
};

ShowQuestions.propTypes = {
  questions: PropTypes.array.isRequired,
  onAnswer: PropTypes.func.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  isReview: PropTypes.bool,
};

